export default "__VITE_ASSET__4031f867__"